module.exports = __webpack_public_path__ + "img/across back.d2c55354.png";